{
  "name": "12-JI (3,5,13)",
  "description": "12-tone Tridecimal-Quintal Rational Intonation scale, derived from harmonic partial row intervals limited to the prime subgroup combining 2, 3, 5, and 13. The typical consonant chord is 10:12:13:15(:16).",
  "scale": [
    "13/12",
    "9/8",
    "39/32",
    "5/4",
    "4/3",
    "45/32",
    "3/2",
    "13/8",
    "5/3",
    "169/96",
    "15/8",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-JI-3.5.13",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "A", "A", "B", "B"],
  "note_colors": [
    "#ffcfcf",
    "#e6d7fe",
    "#ffffff",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#e6e0cb",
    "#ffffff",
    "#e6d7fe",
    "#fffae5",
    "#dbb3ff",
    "#fffae5"
  ],
  "equivSteps": 12,
  "fundamental": 260.740741,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
